// The trail's scenery: one kit part per layer, drawn in its own 100 × 100 box.
// The layer carries no position; the renderer places it and scales it by size / 100.

import type { Layer } from "./draw.ts";
import { BOX, placePart } from "./kit/index.ts";

export type SceneryPart = "apricot-tree" | "poplar" | "khachkar";

// A layer is built from the part alone, so each part is drawn once and every
// spot that shows it shares the same object.
const layers = new Map<SceneryPart, Layer>();

export function sceneryLayer(spot: { part: SceneryPart }): Layer {
	const cached = layers.get(spot.part);
	if (cached) return cached;
	const layer: Layer = {
		id: `trail:${spot.part}`,
		box: { w: BOX, h: BOX },
		ratio: 1,
		shade: "shadeNear",
		// placePart puts the part's box origin at (x, y); the origin is the box's corner
		items: placePart({ part: spot.part, x: 0, y: 0, detail: "vignette" }),
	};
	layers.set(spot.part, layer);
	return layer;
}
